// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BindingExpiration, BindingExpirationSchema } from 'api/gen/BindingExpiration';

const requiredPart = t.interface({
  bindingExpiration: BindingExpirationSchema,
  farmIds: t.union([t.array(t.Integer), t.null]),
  hasAccessToAllFarms: t.boolean,
  roleId: t.Integer,
  userProfileBreederRoleId: t.Integer,
});

export const BreederRoleManagementSchema = excess(requiredPart);

export interface BreederRoleManagement extends t.TypeOf<typeof BreederRoleManagementSchema> {}
